import { ISolutionFeatureFragment, ISolutionSubTopicFragment } from 'src/graphql/generated/hooks'
import { FeaturesType, SectionItem } from 'src/types'

import { apolloSdk } from '../graphql/apolloSdk'
import { checkNotEmpty } from './checkNotEmpty'

export const getFeaturesItems = (
  subTopics: ISolutionSubTopicFragment[],
  solutionFeatures: ISolutionFeatureFragment[],
) => {
  const featuresItems: SectionItem[] = []
  subTopics.map((subTopic) => {
    const features = subTopic.attributes?.features?.data || []
    if (checkNotEmpty(features)) {
      const convertedItems: FeaturesType[] = features.map((item) => {
        const converted: FeaturesType = {
          name: item?.attributes?.name || '',
          isChecked:
            solutionFeatures.filter((feature) => item.attributes?.name === feature.attributes?.name).length > 0,
        }
        return converted
      })
      convertedItems.sort((a) => (a.isChecked ? 1 : 0))

      featuresItems.push({
        title: `${subTopic.attributes?.name || ''} Key Features`,
        type: 'CheckDataList',
        subType: 'cart',
        items: convertedItems,
        isFullWidth: true,
      })
    }
  })

  return featuresItems
}

export const getFeaturesCheckedItem = async (solutionFeatures: ISolutionFeatureFragment[]) => {
  const features = await apolloSdk.allFeatures()
  const allFeatures = features.features?.data || []
  const featuresItems: SectionItem[] = []
  if (checkNotEmpty(allFeatures)) {
    const convertedItems: FeaturesType[] = allFeatures.map((feat) => {
      const currentName = feat.attributes?.name
      const converted: FeaturesType = {
        name: currentName || '',
        isChecked: solutionFeatures.filter((feature) => currentName === feature.attributes?.name).length > 0,
      }
      return converted
    })
    convertedItems.sort((a) => (a.isChecked ? 1 : 0))
    featuresItems.push({
      title: 'OPTIONAL SUBHEADER',
      type: 'CheckDataList',
      subType: 'cart',
      items: convertedItems,
      isFullWidth: true,
      colValue: 2,
    })
  }
  return featuresItems
}
